import useActiveState from "../../lib/useActiveState";
import { Link } from "react-router-dom";
import { useEffect, useState, useRef } from "react";
import { useThrottleEffect, useLocalStorageState } from "ahooks";
import general from "../../general";
import Dialog from "../../lib/Dialog";
import SwiperCore, { Autoplay } from "swiper";
import { Swiper, SwiperSlide } from "swiper/react";

SwiperCore.use([Autoplay]);

// 首页顶部搜索框
export default (props) => {
  let [kws, setKws] = useLocalStorageState("search-kws", {
    defaultValue: [],
  });
  const [dataLoaded, setDataLoaded] = useState(false);
  const swiperRef = useRef(null);

  useEffect(() => {
    general.axios
      .get("/v3/base/search/index", {
        headers: { username: "" },
      })
      .then((res) => {
        let { status, data } = res.data;
        console.log("搜索页数据", data);
        if (!status.succeed) {
          return;
        }
        kws = data.search_keyword;
        setKws(data.search_keyword);
        setDataLoaded(true);
      })
      .catch((err) => {
        console.log("search " + err.message);
        // 即使请求失败，也设置数据已加载，使用默认值
        setDataLoaded(true);
      });
  }, []);

  // 当 Swiper 创建时，启动 autoplay
  const onSwiper = (swiper) => {
    swiperRef.current = swiper;
    if (props.active) {
      // 延迟一下确保 Swiper 完全初始化
      setTimeout(() => {
        if (swiper.autoplay) {
          swiper.autoplay.start();
        }
      }, 100);
    }
  };

  // 当组件重新激活时，重新启动 Swiper 的 autoplay
  useEffect(() => {
    if (props.active && swiperRef.current) {
      // 延迟一下确保 Swiper 已经渲染完成
      setTimeout(() => {
        if (swiperRef.current?.autoplay) {
          swiperRef.current.autoplay.start();
        }
      }, 200);
    } else if (!props.active && swiperRef.current) {
      // 当组件失活时，停止 autoplay
      if (swiperRef.current.autoplay) {
        swiperRef.current.autoplay.stop();
      }
    }
  }, [props.active]);

  return (
    <div className="classify-head-content">
      <div className="status-bar-background"></div>

      <Link to="/search" className="search">
        <img className="search-img" src="/resources/common/search.png" alt="" />

        {dataLoaded && kws.length > 0 ? (
          <div className="search-index-input-main">
            <div className="search-index-input-main-swiper">
              <Swiper
                onSwiper={onSwiper}
                autoplay={{
                  delay: 3000,
                  disableOnInteraction: false,
                }}
                loop={true}
                direction="vertical"
              >
                {kws.map((item, index) => (
                  <SwiperSlide
                    key={index}
                    className="search-index-input-main-swiper-slide"
                  >
                    <div className="search-index-input-main-swiper-slide-text">
                      {item}
                    </div>
                  </SwiperSlide>
                ))}
              </Swiper>
            </div>
          </div>
        ) : (
          <span>搜一搜</span>
        )}
      </Link>
    </div>
  );
};
